import { useEffect, useState } from "react";
import { CategoryProductsEffectActions } from "../../../../common/services/category-products/category-products.service";
import { Loaders } from "../../../../common/store/loaders/loaders.enum";
import { CategoryProductType } from "../../../../constants/category.constants";
import useActions from "../../../../hooks/service-actions.hook";
import useLoaders from "../../../../hooks/use-loaders.hook";
import "./index.styles.scss";
import { useEntity } from "../../../../hooks/use-entity.hook";
import { Entities } from "../../../../common/store/entities/entities.enum";
import SlidingModal from "../../../CustomModal/SlidingModal";
import { Nav, Tab } from "react-bootstrap";
import ProductsTab from "./products.tab";
import { ROUTE_PATHS } from "../../../../constants/app.constants";

const ClientTypeSelection = [{
  label: 'TechSpend',
  value: CategoryProductType.TechSpend,
}, {
  label: 'Storefront',
  value: CategoryProductType.Storefront,
}]

const ViewProductsModal = ({ show, onHide, category }) => {
  const { isLoading } = useLoaders({ loaders: [Loaders.GetCategoryProductsLoader] })
  const { getCategoryProducts } = useActions(CategoryProductsEffectActions);
  const [defaultSelectedTab, setDefaultSelectedTab] = useState(ClientTypeSelection[1]);
  const { entityData: categoryProductsFromStore } = useEntity({ entityType: Entities.CategoryProducts, entityId: category?.categoryId });
  const categoryProducts = categoryProductsFromStore?.[defaultSelectedTab.value]?.ProductList ?? [];

  useEffect(() => {
    if (!show) return;
    getCategoryProducts({
      categoryId: category?.categoryId,
      type: ClientTypeSelection.findIndex((item) => item === defaultSelectedTab),
    });
  }, [category?.categoryId, show, defaultSelectedTab]);

  return (
    <SlidingModal
      show={show}
      dialogClassName="view-products-modal position-relative"
      className="view-products-modal"
      aria-labelledby="view-products-modal "
      id="0016sqxw123asd"
      onHide={onHide}
    >
      <SlidingModal.Header className="text-center d-flex p-3 border-bottom">
        <div className="d-flex align-items-center justify-content-center w-100 gap-4">
          <div className="category-color" style={{ backgroundColor: category?.categoryHexColor }} />
          <div
            className="mb-0 font-bold-14 title"
            style={{ fontWeight: "600" }}
          >
            {category?.categoryName}
          </div>
          {category?.isCustom && (
            <div className="custom-label">
              Custom
            </div>
          )}
        </div>

        <span className="cursor-pointer" onClick={onHide}>
          <img src="/images/attack-surface/cross-icon.svg" alt="" />
        </span>
      </SlidingModal.Header>
      <SlidingModal.Body>
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey={defaultSelectedTab.value}
          onSelect={(e) => {
            setDefaultSelectedTab(ClientTypeSelection[e]);
          }}
        >
          <div className="products-body">
            <div
              className="nav-header-container hide-border d-flex justify-content-between align-items-center ml- p-0"
            >
              <Nav
                variant="pills"
                className="flex-row"
              >
                {ClientTypeSelection.map((clientType) => (
                  <Nav.Item key={clientType.value}>
                    <Nav.Link eventKey={clientType.value}>{clientType.label}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </div>
            <Tab.Content className="hide-scrollbar overflow-y-auto">
              <Tab.Pane eventKey={ClientTypeSelection[0].value}>
                <ProductsTab
                  products={categoryProducts} 
                  redirectAreaPath={""} 
                  isLoading={isLoading}
                />
              </Tab.Pane>
              <Tab.Pane eventKey={ClientTypeSelection[1].value}>
                <ProductsTab 
                  products={categoryProducts} 
                  redirectAreaPath={""} 
                  isLoading={isLoading}
                />
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </SlidingModal.Body>
    </SlidingModal>
  )
}

export default ViewProductsModal;
